import $ from 'cash-dom'
import { checkMatch } from '../snippets/match-media'

export const initCarousel = (selector) => {
  $(selector).each(function () {
    let carousel
    const $this = $(this)
    const init = (config) => {
      if (carousel) {
        carousel.destroy()
      }
      carousel = new Flickity(selector, config)
      $this.siblings('.carousel-prev').on('click', () => {
        carousel.previous()
      })
      $this.siblings('.carousel-next').on('click', () => {
        carousel.next()
      })
    }
    checkMatch({
      mq: '(min-width: 1024px)',
      onMatch: () => {
        init({
          prevNextButtons: false,
          freeScroll: true,
          draggable: true,
          pageDots: false,
          wrapAround: true,
          cellAlign: 'left',
        })
      },
      onUnmatch: () => {
        init({
          prevNextButtons: false,
          freeScroll: false,
          draggable: true,
          pageDots: false,
          wrapAround: true,
          cellAlign: 'left',
        })
      },
    })
  })
}
